import { useLoginBanner } from '@cobliteam/hooks/src/useEntity/usePrismic';
import { PrismicButton, PrismicImage, PrismicRichText } from '@cobliteam/prismic';
import Loading from '@cobliteam/ui/components/Loading';
import Typography from '@cobliteam/ui/components/Typography';
import { cn } from '@cobliteam/ui/utils';

const LoginMKT = () => {
  const { data, isPending, isError } = useLoginBanner();
  if (!data && isPending) {
    return (
      <div className='flex h-screen items-center justify-center bg-primary-10'>
        <Loading fill='#fff' />
      </div>
    );
  }
  if (!data || isError) {
    return (
      <div className='flex h-screen items-center justify-center bg-primary-10'>
        <Typography variant='body' color='white'>
          Ocorreu um erro ao carregar o conteúdo
        </Typography>
      </div>
    );
  }
  const content = data.data;
  return (
    <div
      className={cn(
        'max-h-screen overflow-hidden bg-primary-10 p-10',
        'laptop:p-[60px] laptop:pb-0',
        'desktop:px-[100px] desktop:py-0',
        'widescreen:px-20 widescreen:py-[250px]',
        'widescreen:bg-[url("/static/images/login/bg-large.svg")] bg-no-repeat max-widescreen:bg-[url("/static/images/login/bg-small.svg")]',
        'desktop:bg-[center_bottom_114px] tablet:bg-[center_bottom_192px] widescreen:bg-[left_center]'
      )}
    >
      <div
        className={cn(
          'flex flex-col items-center justify-start gap-[100px]',
          'desktop:max-widescreen:grid desktop:max-widescreen:max-h-screen desktop:max-widescreen:grid-cols-1 desktop:max-widescreen:grid-rows-2 desktop:max-widescreen:gap-20',
          'widescreen:flex-row-reverse widescreen:items-center widescreen:justify-between widescreen:gap-10'
        )}
      >
        <div className={cn('flex flex-col gap-5', 'laptop:max-desktop:mt-9', 'desktop:max-widescreen:h-full desktop:max-widescreen:justify-end')}>
          <PrismicRichText field={content.title} className='text-white' />
          <PrismicRichText field={content.description} className='text-white' />
          <div className='flex gap-3'>
            {content.buttons.map((button, idx) => (
              <PrismicButton button={button} key={idx} analytics_track={content.analytics_track} className='mt-6 w-36' />
            ))}
          </div>
        </div>
        <div className={cn('flex w-full flex-1 justify-center', 'desktop:max-widescreen:max-h-[calc(50vh-40px)] desktop:max-widescreen:content-start')}>
          <PrismicImage
            field={content.image}
            className='h-full max-h-full w-full widescreen:w-[345px] max-w-[419px] object-contain'
            widths={[304, 392, 419, 345]}
            imgixParams={{
              q: 75,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginMKT;
